import Service from '../Service'

export default class OcorrenciaTipoService extends Service{
    constructor(){
        super('OcorrenciaTipo');
    }
}
